const state = () => ({
  showNewEndpoint: false,
  showNewGroup: false,
  globalNotification: [],
  waitingLoader: "",
  errors: []
});
const mutations = {
  setNewEndpointVisible(state, authData) {
    state.showNewEndpoint = authData.showNewEndpoint;
  },
  setNewGroupVisible(state, authData) {
    state.showNewGroup = authData.showNewGroup;
  },
  setWaitingLoader(state, loaderText) {
    state.waitingLoader = loaderText;
  },
  setGlobalNotification(state, notification) {
    state.globalNotification = state.globalNotification.concat([notification]);
  },
  clearGlobalNotification(state) {
    state.globalNotification = [];
  },
  setError(state, error) {
    if (state.errors.includes(error)) return
    state.errors = state.errors.concat(error);
  },
  clearErrors(state) {
    state.errors = [];
  }
};
const actions = {
  /*AutoHideMenu({ commit }) {
    if (localStorage.getItem("IsMenuHidden") == "true") {
      commit("setHiddenMenu", {
        value: true
      });
    } else {
      commit("setHiddenMenu", {
        value: false
      });
    }
  }*/
};
const getters = {
  globalNotification: state => {
    return state.globalNotification;
  },
  ifNewEndpointVisible: state => {
    return state.showNewEndpoint;
  },
  ifNewGroupVisible: state => {
    return state.showNewGroup;
  },
  waitingLoader: state => {
    return state.waitingLoader;
  }
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
